var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdministration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.249,
    height: 21.362,
    viewBox: "0 0 17.249 21.362",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30770",
    "data-name": "Group 30770",
    transform: "translate(14190.75 13207.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30771",
    "data-name": "Group 30771",
    transform: "translate(-14190 -13207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M19.749,22.906V18.937A3.937,3.937,0,0,0,15.812,15H7.937A3.937,3.937,0,0,0,4,18.937v3.969",
    transform: "translate(-4 -4.174)",
    fill: "none",
    stroke: "#9d9fab",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_340",
    "data-name": "Ellipse 340",
    cx: 4.208,
    cy: 4.208,
    r: 4.208,
    transform: "translate(3.666 0)",
    fill: "none",
    stroke: "#9d9fab",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65885",
    "data-name": "Path 65885",
    d: "M0,16.851",
    fill: "none",
    stroke: "#9d9fab",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_30772",
    "data-name": "Group 30772",
    transform: "translate(62.274 -42.698)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67888",
    "data-name": "Path 67888",
    d: "M8.5,18.882A1.416,1.416,0,1,0,9.913,20.3,1.416,1.416,0,0,0,8.5,18.882Zm0,2.124A.708.708,0,1,1,9.2,20.3.707.707,0,0,1,8.5,21.006Z",
    transform: "translate(-14253.171 -13168.203)",
    fill: "#9d9fab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67889",
    "data-name": "Path 67889",
    d: "M11.616,20.767l-.157-.093a3.216,3.216,0,0,0,0-1.165l.157-.093a1.063,1.063,0,0,0-.941-1.906.964.964,0,0,0-.12.07l-.158.093a3.185,3.185,0,0,0-1.008-.582v-.183a1.063,1.063,0,0,0-2.124-.063c0,.021,0,.042,0,.063v.182a3.177,3.177,0,0,0-1.008.583L6.1,17.58a1.064,1.064,0,1,0-1.063,1.842l.157.093a3.216,3.216,0,0,0,0,1.165l-.157.093A1.062,1.062,0,0,0,6.1,22.608l.158-.093a3.162,3.162,0,0,0,1.009.582v.182a1.063,1.063,0,0,0,2.124,0V23.1a3.178,3.178,0,0,0,1.008-.583l.158.093a1.064,1.064,0,1,0,1.063-1.843Zm-.9-1.337a2.5,2.5,0,0,1,0,1.328.354.354,0,0,0,.164.4l.384.221a.354.354,0,0,1-.354.613l-.385-.222a.354.354,0,0,0-.43.059,2.475,2.475,0,0,1-1.148.664.354.354,0,0,0-.266.343v.443a.354.354,0,0,1-.708,0v-.443a.354.354,0,0,0-.266-.343,2.472,2.472,0,0,1-1.15-.666.354.354,0,0,0-.43-.059l-.384.222a.354.354,0,1,1-.354-.613l.384-.221a.354.354,0,0,0,.164-.4,2.5,2.5,0,0,1,0-1.328.354.354,0,0,0-.164-.4l-.384-.221a.354.354,0,1,1,.354-.613l.385.222a.354.354,0,0,0,.429-.057A2.475,2.475,0,0,1,7.7,17.7a.354.354,0,0,0,.266-.345v-.443a.354.354,0,0,1,.708,0v.443a.354.354,0,0,0,.266.343,2.474,2.474,0,0,1,1.148.666.354.354,0,0,0,.43.059l.384-.222a.354.354,0,1,1,.354.613l-.384.221a.354.354,0,0,0-.164.4Z",
    transform: "translate(-14253 -13168)",
    fill: "#9d9fab"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministration);
export default __webpack_public_path__ + "static/media/Administration.e09690160f2ac4d86e2321271b42e913.svg";
export { ForwardRef as ReactComponent };